'use es6';

import { Component } from 'react';
import UISelectableButton from 'UIComponents/button/UISelectableBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class SkeletonTimePicker extends Component {
  constructor(...args) {
    super(...args);
    this.renderTimePickerButtons = () => {
      return [...Array(4)].map((value, index) => {
        return /*#__PURE__*/_jsx(View, {
          paddingBlock: "100",
          paddingInlineEnd: "100",
          as: "div",
          children: /*#__PURE__*/_jsx(UISelectableButton, {
            block: true,
            padded: false,
            selected: false,
            className: "time-picker-btn",
            children: /*#__PURE__*/_jsx("div", {
              className: "skeleton"
            })
          })
        }, index);
      });
    };
    this.renderInputs = () => {
      return /*#__PURE__*/_jsx("div", {
        className: "time-list-container",
        children: /*#__PURE__*/_jsx("div", {
          className: "time-list",
          children: this.renderTimePickerButtons()
        })
      });
    };
  }
  render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "time-picker time-picker-skeleton width-100",
      children: [/*#__PURE__*/_jsx(H5, {
        className: "skeleton-text",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "prebook.timePicker.header"
        })
      }), this.renderInputs()]
    });
  }
}